import { z } from 'zod';
// Zod schemas for runtime validation
const InjectionScriptMessageSchema = z.object({
    action: z.literal('proxyRpcCall'),
    method: z.string(),
    data: z.unknown(), // Use runtime validation from shared types
    pageId: z.string(),
    requestId: z.string(),
    parentOrigin: z.string(),
    url: z.string(),
});
const UtilityMessageSchema = z.object({
    action: z.enum(['getCurrentTabId', 'serviceWorkerWakeUp', 'getMimeType']),
    timestamp: z.number().optional(),
});
const PageRegistrationMessageSchema = z.object({
    action: z.literal('registerPage'),
    data: z.object({
        pageId: z.string(),
        url: z.string(),
        timestamp: z.number(),
    }),
});
const CspViolationMessageSchema = z.object({
    action: z.literal('cspViolation'),
    data: z.object({
        pageId: z.string(),
        url: z.string(),
        violatedDirective: z.string(),
    }),
});
const ScriptInjectionFailedMessageSchema = z.object({
    action: z.literal('scriptInjectionFailed'),
    data: z.object({
        pageId: z.string(),
        url: z.string(),
    }),
});
// Extension signal validation is now handled by shared types
export function isInjectionScriptMessage(message) {
    return InjectionScriptMessageSchema.safeParse(message).success;
}
export function isUtilityMessage(message) {
    return UtilityMessageSchema.safeParse(message).success;
}
export function isPageRegistrationMessage(message) {
    return PageRegistrationMessageSchema.safeParse(message).success;
}
export function isCspViolationMessage(message) {
    return CspViolationMessageSchema.safeParse(message).success;
}
export function isScriptInjectionFailedMessage(message) {
    return ScriptInjectionFailedMessageSchema.safeParse(message).success;
}
// Extension signal validation is exported from shared types
export { isExtensionSignal } from '../shared/types';
